/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CleanupOldMetricsParams,
  GetServiceHealthParams,
  GetServiceLogsParams,
  GetServiceMetricsByDateRangeParams,
  GetServiceSummaryParams,
  GetServicesWithFailuresParams,
  GetTopServicesParams,
  PageServiceMetricLogDTO,
  ServiceHealthDTO,
  ServiceMetricDTO,
  ServiceMetricSummaryDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get top services by request count
 * @summary Get top services
 */
export const getTopServices = (
    params?: GetTopServicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceMetricDTO[]>(
      {url: `/api/service-metrics/top`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTopServicesInfiniteQueryKey = (params?: GetTopServicesParams,) => {
    return [
    'infinite', `/api/service-metrics/top`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetTopServicesQueryKey = (params?: GetTopServicesParams,) => {
    return [
    `/api/service-metrics/top`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTopServicesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getTopServices>>>, TError = unknown>(params?: GetTopServicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTopServicesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopServices>>> = ({ signal }) => getTopServices(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTopServicesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTopServices>>>
export type GetTopServicesInfiniteQueryError = unknown


export function useGetTopServicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTopServices>>>, TError = unknown>(
 params: undefined |  GetTopServicesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopServices>>,
          TError,
          Awaited<ReturnType<typeof getTopServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTopServicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTopServices>>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopServices>>,
          TError,
          Awaited<ReturnType<typeof getTopServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTopServicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTopServices>>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get top services
 */

export function useGetTopServicesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTopServices>>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTopServicesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTopServicesQueryOptions = <TData = Awaited<ReturnType<typeof getTopServices>>, TError = unknown>(params?: GetTopServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTopServicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopServices>>> = ({ signal }) => getTopServices(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTopServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getTopServices>>>
export type GetTopServicesQueryError = unknown


export function useGetTopServices<TData = Awaited<ReturnType<typeof getTopServices>>, TError = unknown>(
 params: undefined |  GetTopServicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopServices>>,
          TError,
          Awaited<ReturnType<typeof getTopServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTopServices<TData = Awaited<ReturnType<typeof getTopServices>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopServices>>,
          TError,
          Awaited<ReturnType<typeof getTopServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTopServices<TData = Awaited<ReturnType<typeof getTopServices>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get top services
 */

export function useGetTopServices<TData = Awaited<ReturnType<typeof getTopServices>>, TError = unknown>(
 params?: GetTopServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopServices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTopServicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get list of all services being tracked
 * @summary Get all service names
 */
export const getAllServiceNames = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/api/service-metrics/services`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllServiceNamesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/service-metrics/services`
    ] as const;
    }

export const getGetAllServiceNamesQueryKey = () => {
    return [
    `/api/service-metrics/services`
    ] as const;
    }

    
export const getGetAllServiceNamesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllServiceNames>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllServiceNamesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllServiceNames>>> = ({ signal }) => getAllServiceNames(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllServiceNamesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllServiceNames>>>
export type GetAllServiceNamesInfiniteQueryError = unknown


export function useGetAllServiceNamesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllServiceNames>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllServiceNamesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllServiceNames>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllServiceNamesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllServiceNames>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all service names
 */

export function useGetAllServiceNamesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllServiceNames>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllServiceNamesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllServiceNamesQueryOptions = <TData = Awaited<ReturnType<typeof getAllServiceNames>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllServiceNamesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllServiceNames>>> = ({ signal }) => getAllServiceNames(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllServiceNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllServiceNames>>>
export type GetAllServiceNamesQueryError = unknown


export function useGetAllServiceNames<TData = Awaited<ReturnType<typeof getAllServiceNames>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllServiceNames<TData = Awaited<ReturnType<typeof getAllServiceNames>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getAllServiceNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllServiceNames<TData = Awaited<ReturnType<typeof getAllServiceNames>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all service names
 */

export function useGetAllServiceNames<TData = Awaited<ReturnType<typeof getAllServiceNames>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllServiceNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllServiceNamesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get metrics for a specific service
 * @summary Get service metrics
 */
export const getServiceMetrics = (
    serviceName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceMetricDTO[]>(
      {url: `/api/service-metrics/services/${serviceName}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetServiceMetricsInfiniteQueryKey = (serviceName?: string,) => {
    return [
    'infinite', `/api/service-metrics/services/${serviceName}`
    ] as const;
    }

export const getGetServiceMetricsQueryKey = (serviceName?: string,) => {
    return [
    `/api/service-metrics/services/${serviceName}`
    ] as const;
    }

    
export const getGetServiceMetricsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetrics>>>, TError = unknown>(serviceName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceMetricsInfiniteQueryKey(serviceName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceMetrics>>> = ({ signal }) => getServiceMetrics(serviceName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceMetricsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceMetrics>>>
export type GetServiceMetricsInfiniteQueryError = unknown


export function useGetServiceMetricsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetrics>>>, TError = unknown>(
 serviceName: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetrics>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetrics>>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetrics>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetrics>>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service metrics
 */

export function useGetServiceMetricsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetrics>>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceMetricsInfiniteQueryOptions(serviceName,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServiceMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceMetrics>>, TError = unknown>(serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceMetricsQueryKey(serviceName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceMetrics>>> = ({ signal }) => getServiceMetrics(serviceName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceMetrics>>>
export type GetServiceMetricsQueryError = unknown


export function useGetServiceMetrics<TData = Awaited<ReturnType<typeof getServiceMetrics>>, TError = unknown>(
 serviceName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetrics>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetrics<TData = Awaited<ReturnType<typeof getServiceMetrics>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetrics>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetrics<TData = Awaited<ReturnType<typeof getServiceMetrics>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service metrics
 */

export function useGetServiceMetrics<TData = Awaited<ReturnType<typeof getServiceMetrics>>, TError = unknown>(
 serviceName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetrics>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceMetricsQueryOptions(serviceName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get aggregated summary with trend data for a service
 * @summary Get service summary
 */
export const getServiceSummary = (
    serviceName: string,
    params?: GetServiceSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceMetricSummaryDTO>(
      {url: `/api/service-metrics/services/${serviceName}/summary`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetServiceSummaryInfiniteQueryKey = (serviceName?: string,
    params?: GetServiceSummaryParams,) => {
    return [
    'infinite', `/api/service-metrics/services/${serviceName}/summary`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetServiceSummaryQueryKey = (serviceName?: string,
    params?: GetServiceSummaryParams,) => {
    return [
    `/api/service-metrics/services/${serviceName}/summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServiceSummaryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceSummary>>>, TError = unknown>(serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceSummaryInfiniteQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceSummary>>> = ({ signal }) => getServiceSummary(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceSummary>>>
export type GetServiceSummaryInfiniteQueryError = unknown


export function useGetServiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceSummary>>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceSummaryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getServiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceSummary>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getServiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceSummary>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service summary
 */

export function useGetServiceSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceSummary>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceSummaryInfiniteQueryOptions(serviceName,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServiceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getServiceSummary>>, TError = unknown>(serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceSummaryQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceSummary>>> = ({ signal }) => getServiceSummary(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceSummary>>>
export type GetServiceSummaryQueryError = unknown


export function useGetServiceSummary<TData = Awaited<ReturnType<typeof getServiceSummary>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getServiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceSummary<TData = Awaited<ReturnType<typeof getServiceSummary>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceSummary>>,
          TError,
          Awaited<ReturnType<typeof getServiceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceSummary<TData = Awaited<ReturnType<typeof getServiceSummary>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service summary
 */

export function useGetServiceSummary<TData = Awaited<ReturnType<typeof getServiceSummary>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceSummaryQueryOptions(serviceName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get metrics for a specific service within a date range
 * @summary Get service metrics by date range
 */
export const getServiceMetricsByDateRange = (
    serviceName: string,
    params: GetServiceMetricsByDateRangeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceMetricDTO[]>(
      {url: `/api/service-metrics/services/${serviceName}/range`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetServiceMetricsByDateRangeInfiniteQueryKey = (serviceName?: string,
    params?: GetServiceMetricsByDateRangeParams,) => {
    return [
    'infinite', `/api/service-metrics/services/${serviceName}/range`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetServiceMetricsByDateRangeQueryKey = (serviceName?: string,
    params?: GetServiceMetricsByDateRangeParams,) => {
    return [
    `/api/service-metrics/services/${serviceName}/range`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServiceMetricsByDateRangeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>, TError = unknown>(serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceMetricsByDateRangeInfiniteQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>> = ({ signal }) => getServiceMetricsByDateRange(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceMetricsByDateRangeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>
export type GetServiceMetricsByDateRangeInfiniteQueryError = unknown


export function useGetServiceMetricsByDateRangeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsByDateRangeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsByDateRangeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service metrics by date range
 */

export function useGetServiceMetricsByDateRangeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceMetricsByDateRangeInfiniteQueryOptions(serviceName,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServiceMetricsByDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError = unknown>(serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceMetricsByDateRangeQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>> = ({ signal }) => getServiceMetricsByDateRange(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceMetricsByDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>>
export type GetServiceMetricsByDateRangeQueryError = unknown


export function useGetServiceMetricsByDateRange<TData = Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsByDateRange<TData = Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>,
          TError,
          Awaited<ReturnType<typeof getServiceMetricsByDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceMetricsByDateRange<TData = Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service metrics by date range
 */

export function useGetServiceMetricsByDateRange<TData = Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError = unknown>(
 serviceName: string,
    params: GetServiceMetricsByDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceMetricsByDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceMetricsByDateRangeQueryOptions(serviceName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get paginated logs for a service
 * @summary Get service logs
 */
export const getServiceLogs = (
    serviceName: string,
    params?: GetServiceLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageServiceMetricLogDTO>(
      {url: `/api/service-metrics/services/${serviceName}/logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetServiceLogsInfiniteQueryKey = (serviceName?: string,
    params?: GetServiceLogsParams,) => {
    return [
    'infinite', `/api/service-metrics/services/${serviceName}/logs`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetServiceLogsQueryKey = (serviceName?: string,
    params?: GetServiceLogsParams,) => {
    return [
    `/api/service-metrics/services/${serviceName}/logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServiceLogsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceLogs>>>, TError = unknown>(serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceLogsInfiniteQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceLogs>>> = ({ signal }) => getServiceLogs(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceLogsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceLogs>>>
export type GetServiceLogsInfiniteQueryError = unknown


export function useGetServiceLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceLogs>>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceLogsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceLogs>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceLogs>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service logs
 */

export function useGetServiceLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceLogs>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceLogsInfiniteQueryOptions(serviceName,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServiceLogsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceLogs>>, TError = unknown>(serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceLogsQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceLogs>>> = ({ signal }) => getServiceLogs(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceLogs>>>
export type GetServiceLogsQueryError = unknown


export function useGetServiceLogs<TData = Awaited<ReturnType<typeof getServiceLogs>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceLogs<TData = Awaited<ReturnType<typeof getServiceLogs>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceLogs<TData = Awaited<ReturnType<typeof getServiceLogs>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service logs
 */

export function useGetServiceLogs<TData = Awaited<ReturnType<typeof getServiceLogs>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceLogsQueryOptions(serviceName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get current health status of a service
 * @summary Get service health
 */
export const getServiceHealth = (
    serviceName: string,
    params?: GetServiceHealthParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceHealthDTO>(
      {url: `/api/service-metrics/services/${serviceName}/health`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetServiceHealthInfiniteQueryKey = (serviceName?: string,
    params?: GetServiceHealthParams,) => {
    return [
    'infinite', `/api/service-metrics/services/${serviceName}/health`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetServiceHealthQueryKey = (serviceName?: string,
    params?: GetServiceHealthParams,) => {
    return [
    `/api/service-metrics/services/${serviceName}/health`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServiceHealthInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceHealth>>>, TError = unknown>(serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceHealthInfiniteQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceHealth>>> = ({ signal }) => getServiceHealth(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceHealthInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceHealth>>>
export type GetServiceHealthInfiniteQueryError = unknown


export function useGetServiceHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceHealth>>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceHealthParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceHealth>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceHealth>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service health
 */

export function useGetServiceHealthInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceHealth>>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceHealthInfiniteQueryOptions(serviceName,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServiceHealthQueryOptions = <TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = unknown>(serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceHealthQueryKey(serviceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceHealth>>> = ({ signal }) => getServiceHealth(serviceName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServiceHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceHealth>>>
export type GetServiceHealthQueryError = unknown


export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = unknown>(
 serviceName: string,
    params: undefined |  GetServiceHealthParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceHealth>>,
          TError,
          Awaited<ReturnType<typeof getServiceHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get service health
 */

export function useGetServiceHealth<TData = Awaited<ReturnType<typeof getServiceHealth>>, TError = unknown>(
 serviceName: string,
    params?: GetServiceHealthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServiceHealthQueryOptions(serviceName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get services that have experienced failures
 * @summary Get services with failures
 */
export const getServicesWithFailures = (
    params?: GetServicesWithFailuresParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceMetricDTO[]>(
      {url: `/api/service-metrics/failures`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetServicesWithFailuresInfiniteQueryKey = (params?: GetServicesWithFailuresParams,) => {
    return [
    'infinite', `/api/service-metrics/failures`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetServicesWithFailuresQueryKey = (params?: GetServicesWithFailuresParams,) => {
    return [
    `/api/service-metrics/failures`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetServicesWithFailuresInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicesWithFailures>>>, TError = unknown>(params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesWithFailuresInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicesWithFailures>>> = ({ signal }) => getServicesWithFailures(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServicesWithFailuresInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicesWithFailures>>>
export type GetServicesWithFailuresInfiniteQueryError = unknown


export function useGetServicesWithFailuresInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicesWithFailures>>>, TError = unknown>(
 params: undefined |  GetServicesWithFailuresParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicesWithFailures>>,
          TError,
          Awaited<ReturnType<typeof getServicesWithFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServicesWithFailuresInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicesWithFailures>>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicesWithFailures>>,
          TError,
          Awaited<ReturnType<typeof getServicesWithFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServicesWithFailuresInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicesWithFailures>>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get services with failures
 */

export function useGetServicesWithFailuresInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicesWithFailures>>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServicesWithFailuresInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServicesWithFailuresQueryOptions = <TData = Awaited<ReturnType<typeof getServicesWithFailures>>, TError = unknown>(params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesWithFailuresQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicesWithFailures>>> = ({ signal }) => getServicesWithFailures(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetServicesWithFailuresQueryResult = NonNullable<Awaited<ReturnType<typeof getServicesWithFailures>>>
export type GetServicesWithFailuresQueryError = unknown


export function useGetServicesWithFailures<TData = Awaited<ReturnType<typeof getServicesWithFailures>>, TError = unknown>(
 params: undefined |  GetServicesWithFailuresParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicesWithFailures>>,
          TError,
          Awaited<ReturnType<typeof getServicesWithFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServicesWithFailures<TData = Awaited<ReturnType<typeof getServicesWithFailures>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicesWithFailures>>,
          TError,
          Awaited<ReturnType<typeof getServicesWithFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetServicesWithFailures<TData = Awaited<ReturnType<typeof getServicesWithFailures>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get services with failures
 */

export function useGetServicesWithFailures<TData = Awaited<ReturnType<typeof getServicesWithFailures>>, TError = unknown>(
 params?: GetServicesWithFailuresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicesWithFailures>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetServicesWithFailuresQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete metrics older than specified days
 * @summary Cleanup old metrics
 */
export const cleanupOldMetrics = (
    params?: CleanupOldMetricsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `/api/service-metrics/cleanup`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getCleanupOldMetricsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupOldMetrics>>, TError,{params?: CleanupOldMetricsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cleanupOldMetrics>>, TError,{params?: CleanupOldMetricsParams}, TContext> => {

const mutationKey = ['cleanupOldMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupOldMetrics>>, {params?: CleanupOldMetricsParams}> = (props) => {
          const {params} = props ?? {};

          return  cleanupOldMetrics(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CleanupOldMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupOldMetrics>>>
    
    export type CleanupOldMetricsMutationError = unknown

    /**
 * @summary Cleanup old metrics
 */
export const useCleanupOldMetrics = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupOldMetrics>>, TError,{params?: CleanupOldMetricsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cleanupOldMetrics>>,
        TError,
        {params?: CleanupOldMetricsParams},
        TContext
      > => {

      const mutationOptions = getCleanupOldMetricsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    